module.exports = __webpack_public_path__ + "static/media/mountains-small.6d5c300e.jpg";